import api from './api';

export const testimonialService = {
  getApprovedTestimonials: async () => {
    try {
      const response = await api.get('/reviews');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des témoignages:', error);
      throw error;
    }
  },

  submitTestimonial: async (data) => {
    try {
      const response = await api.post('/reviews', data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la soumission du témoignage:', error);
      throw error;
    }
  },

  getAllTestimonials: async () => {
    try {
      const response = await api.get('/reviews/all');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des témoignages:', error);
      throw error;
    }
  },

  updateTestimonial: async (id, data) => {
    try {
      const response = await api.patch(`/reviews/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour du témoignage:', error);
      throw error;
    }
  },

  deleteTestimonial: async (id) => {
    try {
      const response = await api.delete(`/reviews/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression du témoignage:', error);
      throw error;
    }
  },
};

export default testimonialService;
